export const RewardsLoanBanner = () => (
  <svg width="194" height="80" viewBox="0 0 194 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_305_8103)">
      <g clipPath="url(#clip1_305_8103)">
        <path
          d="M22.3432 64.5384C7.62171 60.7133 3.32078 46.8402 6.85606 33.024C9.69853 21.9154 20.1263 14.9218 32.3839 13.2663C47.5581 11.2167 60.4356 25.1071 61.3244 39.1402C62.3521 55.3667 39.2867 68.9409 22.3432 64.5384Z"
          fill="#E6EFFF"
        />
        <rect
          width="40.9574"
          height="52.7397"
          rx="2.31329"
          transform="matrix(-0.992366 0.123326 0.123326 0.992366 50.9702 10.6545)"
          fill="#0247B8"
        />
        <path
          d="M57.2283 61.0035L22.2199 65.3542C20.952 65.5118 19.7965 64.6117 19.6389 63.3438L14.567 22.5319L53.843 34.3333L57.2283 61.0035Z"
          fill="#00307A"
        />
        <path
          d="M48.299 15.6266C48.1594 14.939 47.5106 14.4765 46.8143 14.5631L15.4269 18.4638C14.6837 18.5561 14.1564 19.2338 14.2495 19.9769L19.6075 62.7286C19.7023 63.485 20.4023 64.0144 21.156 63.8996L55.2584 58.7052C56.1538 58.5688 56.6648 57.6071 56.3014 56.7775C49.8137 41.9662 51.4656 31.2267 48.299 15.6266Z"
          fill="#F0F5FF"
        />
        <path
          d="M48.6692 17.1595C48.6694 16.9766 48.6458 16.7456 48.5869 16.4971L48.2541 13.8189L46.5837 14.0264L46.6529 14.5832C47.8756 14.7738 48.4032 15.7211 48.5869 16.4971L48.6692 17.1595Z"
          fill="#0247B8"
        />
        <path
          d="M49.5307 30.8974L19.6373 62.9288C19.1704 63.4291 19.5952 64.238 20.2722 64.1375L55.7366 58.8734C56.4437 58.7685 56.8815 58.0448 56.6524 57.3677C53.3044 47.4748 52.175 43.5588 50.7819 31.3166C50.712 30.702 49.9527 30.4451 49.5307 30.8974Z"
          fill="#CCDFFF"
        />
        <rect
          x="20.9869"
          y="31.7316"
          width="3.91055"
          height="3.91346"
          rx="0.723158"
          transform="rotate(-6.47795 20.9869 31.7316)"
          stroke="#85B3FF"
          strokeWidth="1.1456"
        />
        <path
          d="M28.0489 32.6748L45.0147 30.6344"
          stroke="#85B3FF"
          strokeWidth="1.1456"
          strokeLinecap="round"
        />
        <rect
          x="22.1325"
          y="38.605"
          width="3.91055"
          height="3.91346"
          rx="0.723158"
          transform="rotate(-6.47795 22.1325 38.605)"
          stroke="#85B3FF"
          strokeWidth="1.1456"
        />
        <path
          d="M29.1934 39.5482L46.1592 37.5078"
          stroke="#85B3FF"
          strokeWidth="1.1456"
          strokeLinecap="round"
        />
        <rect
          x="23.2781"
          y="46.6244"
          width="3.91055"
          height="3.91346"
          rx="0.723158"
          transform="rotate(-6.47795 23.2781 46.6244)"
          stroke="#75AFFF"
          strokeWidth="1.1456"
        />
        <path
          d="M30.3401 46.9946L47.3059 44.9542"
          stroke="#85B3FF"
          strokeWidth="1.1456"
          strokeLinecap="round"
        />
        <rect
          x="23.8509"
          y="52.9251"
          width="3.91055"
          height="3.91346"
          rx="0.723158"
          transform="rotate(-6.47795 23.8509 52.9251)"
          stroke="#85B3FF"
          strokeWidth="1.1456"
        />
        <path
          d="M30.9129 53.8683L47.8787 51.8279"
          stroke="#85B3FF"
          strokeWidth="1.1456"
          strokeLinecap="round"
        />
        <path
          d="M8.50738 56.934C7.98523 58.4338 5.43202 61.1149 3.41285 63.073C2.10463 64.3417 2.16984 66.5212 3.63389 67.6064C6.30561 69.5867 8.67209 70.9687 12.4134 71.4139C13.4782 71.5405 14.4894 70.9685 14.9868 70.0185C15.5248 68.9912 16.2292 67.5668 16.8075 66.129C17.9069 63.3951 24.029 60.1737 25.3672 58.2177C26.7054 56.2618 28.7042 49.5768 28.7042 49.5768L36.4183 41.0607C36.6804 40.7714 36.6633 40.3289 36.354 40.0907C35.6008 39.5104 34.1717 38.6104 32.857 38.9072C29.6236 39.6369 26.3155 42.9616 24.7898 44.6718C24.4062 45.1018 23.6782 44.9656 23.4956 44.4189L22.5838 41.6899C22.4778 41.3726 22.4836 41.0285 22.6265 40.726C22.9923 39.9512 23.8296 38.4359 25.0228 37.8128C26.1715 37.2129 28.8087 38.4083 30.9147 37.5644C31.8105 37.2055 32.7283 36.276 33.3202 35.5884C33.6487 35.2068 33.4508 34.6402 32.962 34.5193C30.6854 33.9562 25.1632 32.7059 22.9986 33.2443C20.2404 33.9305 13.908 37.3315 11.9008 40.2654C9.89353 43.1993 9.39667 54.3797 8.50738 56.934Z"
          fill="#B67A4B"
        />
        <path
          d="M21.7292 46.0263L18.9255 38.6035L22.6413 39.6383C22.6413 39.6383 22.7755 42.1284 23.5938 43.407C23.7477 43.6475 23.9729 43.9187 24.1821 44.1522C24.4658 44.4686 24.4511 44.963 24.1291 45.2404L22.8777 46.3186C22.4972 46.6465 21.9067 46.4961 21.7292 46.0263Z"
          fill="#A75925"
        />
        <path
          d="M3.89783 39.4932C3.50091 39.5375 3.21509 39.8953 3.25943 40.2922L3.43718 41.8832C3.48152 42.2802 3.83924 42.566 4.23616 42.5216L35.1559 39.0673L38.8469 37.4697C39.1741 37.3281 39.1205 36.8485 38.7701 36.7826L34.8175 36.0389L3.89783 39.4932Z"
          fill="#00307A"
        />
        <rect
          x="18.5848"
          y="12.2007"
          width="23.6622"
          height="8.19076"
          rx="1.44632"
          transform="rotate(-7.04965 18.5848 12.2007)"
          fill="#85B3FF"
        />
        <circle
          cx="30.3259"
          cy="10.7488"
          r="4.55042"
          transform="rotate(-7.04965 30.3259 10.7488)"
          fill="#85B3FF"
        />
        <circle
          cx="30.3264"
          cy="10.7488"
          r="1.82017"
          transform="rotate(-7.04965 30.3264 10.7488)"
          fill="white"
        />
        <path
          d="M19.1419 16.7167L42.6252 13.8126L42.8945 15.9901C42.9925 16.7828 42.4294 17.5049 41.6366 17.603L21.0241 20.152C20.2313 20.25 19.5092 19.6869 19.4112 18.8941L19.1419 16.7167Z"
          fill="#3280FB"
        />
      </g>
      <circle cx="60.9812" cy="56.4832" r="15.3748" fill="#3FB5A0" />
      <path
        d="M23.4048 28.6249L23.4586 29.0328L21.4943 29.2915L21.1492 26.6725L23.0611 26.4206L23.1149 26.8284L21.6894 27.0162L21.7791 27.6972L23.0437 27.5306L23.0964 27.9309L21.8318 28.0975L21.9269 28.8196L23.4048 28.6249ZM25.5093 28.7626L24.6673 27.861L24.095 28.9489L23.5413 29.0219L24.3381 27.558L23.2486 26.3959L23.7986 26.3234L24.5911 27.1668L25.1306 26.148L25.6582 26.0785L24.9081 27.4639L26.0706 28.6887L25.5093 28.7626ZM26.9861 25.9035C27.2131 25.8736 27.4151 25.8851 27.5921 25.9379C27.7716 25.9904 27.9154 26.0805 28.0236 26.2084C28.1318 26.3362 28.1985 26.4962 28.2238 26.6883C28.2488 26.8778 28.2258 27.0496 28.1547 27.2036C28.0833 27.3552 27.9677 27.4795 27.808 27.5767C27.6507 27.6735 27.4586 27.7369 27.2316 27.7668L26.6404 27.8447L26.74 28.6005L26.2536 28.6645L25.9086 26.0455L26.9861 25.9035ZM27.1549 27.3582C27.3669 27.3303 27.5219 27.2642 27.6198 27.1599C27.7178 27.0557 27.7557 26.92 27.7337 26.7528C27.7117 26.5857 27.6399 26.4645 27.5183 26.3892C27.3967 26.3138 27.2299 26.2901 27.0179 26.318L26.4492 26.393L26.5862 27.4331L27.1549 27.3582ZM30.7302 27.6599L30.7839 28.0677L28.8196 28.3265L28.4746 25.7074L30.3865 25.4556L30.4402 25.8634L29.0147 26.0512L29.1044 26.7321L30.3691 26.5655L30.4218 26.9659L29.1572 27.1325L29.2523 27.8546L30.7302 27.6599ZM32.9275 27.7853L32.2914 27.0888C32.2693 27.0943 32.2358 27.0999 32.1909 27.1059L31.5997 27.1837L31.7003 27.947L31.2139 28.0111L30.8689 25.392L31.9464 25.2501C32.1734 25.2202 32.3754 25.2316 32.5524 25.2844C32.7319 25.3369 32.8757 25.4271 32.9839 25.5549C33.0921 25.6828 33.1588 25.8427 33.1841 26.0348C33.2101 26.2319 33.1838 26.4079 33.1053 26.5629C33.0292 26.7175 32.906 26.8416 32.7356 26.9351L33.4513 27.7163L32.9275 27.7853ZM32.694 26.0994C32.672 25.9323 32.6002 25.811 32.4786 25.7357C32.357 25.6604 32.1902 25.6366 31.9782 25.6646L31.4095 25.7395L31.547 26.7834L32.1157 26.7085C32.3277 26.6805 32.4827 26.6144 32.5806 26.5102C32.6782 26.4034 32.716 26.2665 32.694 26.0994ZM33.4933 25.0463L33.9797 24.9822L34.3248 27.6013L33.8384 27.6653L33.4933 25.0463ZM36.8315 26.8561L36.8852 27.2639L34.9209 27.5227L34.5759 24.9037L36.4878 24.6518L36.5416 25.0596L35.116 25.2474L35.2057 25.9284L36.4704 25.7618L36.5231 26.1621L35.2585 26.3287L35.3536 27.0508L36.8315 26.8561ZM39.2974 24.2816L39.6425 26.9007L39.2421 26.9535L37.5642 25.3702L37.7979 27.1437L37.3152 27.2073L36.9702 24.5882L37.3705 24.5355L39.0484 26.1187L38.8148 24.3452L39.2974 24.2816ZM41.4492 26.7008C41.1848 26.7356 40.9378 26.7098 40.7081 26.6233C40.4807 26.534 40.2924 26.3951 40.1432 26.2067C39.9965 26.0179 39.9063 25.7951 39.8724 25.5382C39.8386 25.2812 39.8693 25.0425 39.9646 24.8218C40.0598 24.6012 40.2059 24.4195 40.4028 24.2769C40.6019 24.1314 40.8336 24.0412 41.098 24.0064C41.3126 23.9781 41.5133 23.9897 41.7002 24.0412C41.8872 24.0927 42.0512 24.1815 42.1921 24.3076L41.9168 24.6446C41.7002 24.465 41.4536 24.3935 41.1767 24.4299C40.9971 24.4536 40.8415 24.5147 40.7098 24.6133C40.5778 24.7093 40.4811 24.8324 40.4197 24.9826C40.3583 25.1328 40.3392 25.2965 40.3626 25.4736C40.3859 25.6507 40.4467 25.8038 40.5449 25.933C40.6431 26.0622 40.7686 26.1573 40.9213 26.2184C41.0736 26.277 41.2396 26.2944 41.4192 26.2708C41.6961 26.2343 41.9156 26.1001 42.0779 25.8681L42.4317 26.126C42.3282 26.2843 42.1916 26.4126 42.0218 26.5111C41.8546 26.6093 41.6637 26.6725 41.4492 26.7008ZM44.7488 25.8131L44.8025 26.2209L42.8382 26.4797L42.4932 23.8606L44.4051 23.6088L44.4588 24.0166L43.0333 24.2044L43.123 24.8853L44.3877 24.7187L44.4404 25.1191L43.1758 25.2857L43.2709 26.0078L44.7488 25.8131Z"
        fill="#84B3FF"
      />
      <path
        d="M69.8711 50.1587L57.2222 62.8076L52.0933 57.6787"
        stroke="white"
        strokeWidth="4.34591"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M103.78 42H98.47V47.25H95.26V42H89.95V39H95.26V33.75H98.47V39H103.78V42Z"
      fill="#616D92"
    />
    <g clipPath="url(#clip2_305_8103)">
      <path
        d="M185.948 31.308C195.931 47.5452 189.971 61.8535 175.679 68.805C164.187 74.3942 145.504 69.9429 133.284 59.9878C118.157 47.664 120.294 25.6195 130.834 14.4753C143.021 1.58918 174.458 12.62 185.948 31.308Z"
        fill="#E6EFFF"
      />
      <path
        d="M172.078 70.8486C171.711 72.6484 157.945 72.8733 157.472 71.127C157 69.3807 157.472 59.1467 160.839 55.0344C165.505 49.3362 174.076 47.892 174.076 47.892C174.076 47.892 174.853 38.9094 175.296 37.7496C175.74 36.5897 178.023 35.7104 178.023 35.7104C178.023 35.7104 178.128 33.9489 178.921 33.2329C179.472 32.7355 180.903 32.4897 180.903 32.4897C180.903 32.4897 181.38 31.4609 182.141 31.0032C183.151 30.3957 184.474 30.6912 184.474 30.6912C184.474 30.6912 184.958 29.7298 185.609 29.2689C186.731 28.4737 188.581 29.0212 188.581 29.0212C188.581 29.0212 189.169 44.1373 188.581 46.3633C187.993 48.5893 183.075 57.5209 180.903 58.9983C177.272 61.4671 173.06 62.6489 172.078 64.6084C171.097 66.5678 172.446 69.0488 172.078 70.8486Z"
        fill="#D9AA7A"
      />
      <path
        d="M161.423 71.9371C161.189 71.0612 172.135 62.5838 172.135 64.622C172.135 66.6601 172.522 71.0898 172.135 71.9371C171.747 72.7843 161.656 72.813 161.423 71.9371Z"
        fill="#D98A45"
      />
      <path
        d="M176.039 40.8066C174.413 43.2135 174.583 47.9154 174.583 47.9154C174.583 47.9154 176.995 46.6139 178.854 44.3827C179.672 43.4019 180.743 42.8232 182.015 42.7094C183.107 42.6116 184.772 43.617 184.772 43.617C184.772 43.617 188.289 36.1918 186.291 33.7848C183.594 30.5338 178.382 37.3361 176.039 40.8066Z"
        fill="#D98A45"
      />
      <path
        d="M176.366 54.3259C180.442 47.5527 187.417 45.7703 185.1 43.0966C179.931 39.3537 177.97 47.1962 172.801 48.0874C167.632 48.9785 164.546 51.0891 161.873 53.5845"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M177.792 35.967L177.435 45.2356"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path d="M181 32.7588V42.0273" stroke="#98511B" strokeWidth="1.29986" strokeLinecap="round" />
      <path
        d="M184.565 30.9764V42.0274"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M135.776 70.3987C136.335 72.8344 149.625 72.8199 149.949 71.2985C150.273 69.7772 149.823 58.6967 146.456 54.5844C141.791 48.8863 133.22 47.4421 133.22 47.4421C133.22 47.4421 132.443 38.4594 131.999 37.2996C131.555 36.1398 129.272 35.2604 129.272 35.2604C129.272 35.2604 129.167 33.4989 128.374 32.783C127.823 32.2856 126.393 32.0398 126.393 32.0398C126.393 32.0398 125.916 31.011 125.154 30.5533C124.144 29.9458 122.822 30.2413 122.822 30.2413C122.822 30.2413 122.337 29.2799 121.687 28.819C120.564 28.0238 118.714 28.5713 118.714 28.5713C118.714 28.5713 118.126 43.6874 118.714 45.9134C119.302 48.1394 124.22 57.071 126.393 58.5483C130.023 61.0172 134.208 62.2643 135.217 63.9988C136.226 65.7333 135.217 67.9629 135.776 70.3987Z"
        fill="#D9AA7A"
      />
      <path
        d="M140.875 71.8678C140.641 70.7464 147.583 56.8025 148.624 60.2587C149.666 63.7149 150.305 70.5294 149.949 71.5235C149.593 72.5177 141.11 72.9891 140.875 71.8678Z"
        fill="#D98A45"
      />
      <path
        d="M131.257 40.3567C132.882 42.7636 132.713 47.4655 132.713 47.4655C132.713 47.4655 130.301 46.164 128.441 43.9328C127.624 42.952 126.552 42.3733 125.28 42.2595C124.188 42.1617 122.524 43.1671 122.524 43.1671C122.524 43.1671 119.007 35.7419 121.004 33.3349C123.702 30.0839 128.914 36.8862 131.257 40.3567Z"
        fill="#D98A45"
      />
      <path
        d="M130.93 53.8761C126.854 47.103 119.879 45.3205 122.196 42.6469C127.365 38.9039 129.326 46.7464 134.495 47.6376C139.664 48.5288 142.776 50.6393 145.45 53.1347"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M129.504 35.5174L129.86 44.7859"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M126.295 32.3089V41.5774"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M122.731 30.5266V41.5775"
        stroke="#98511B"
        strokeWidth="1.29986"
        strokeLinecap="round"
      />
      <path
        d="M179.856 17.1644C180.195 16.7784 180.831 17.0225 180.825 17.5361L180.802 19.4631C180.8 19.6246 180.869 19.7789 180.99 19.8855L182.438 21.1573C182.824 21.4963 182.58 22.1325 182.066 22.1263L180.139 22.1033C179.978 22.1014 179.823 22.1701 179.717 22.2914L178.445 23.7393C178.106 24.1252 177.47 23.8811 177.476 23.3675L177.499 21.4405C177.501 21.279 177.432 21.1247 177.311 21.0182L175.863 19.7463C175.477 19.4073 175.721 18.7712 176.235 18.7773L178.162 18.8003C178.323 18.8023 178.477 18.7335 178.584 18.6122L179.856 17.1644Z"
        fill="#85B3FF"
      />
      <circle cx="172.854" cy="12.2057" r="1.10668" fill="#85B3FF" />
      <circle cx="131.908" cy="25.8541" r="1.10668" fill="#85B3FF" />
      <circle
        cx="154.746"
        cy="24.1955"
        r="17.4438"
        transform="rotate(26.3306 154.746 24.1955)"
        fill="#FFCC60"
      />
      <path
        d="M170.567 31.5558L167.553 30.0643C160.159 42.3508 148.766 40.3861 143.993 37.8679C158.091 46.9084 167.583 37.4267 170.567 31.5558Z"
        fill="#B75327"
        stroke="#B75327"
        strokeWidth="0.59445"
      />
      <circle
        cx="152.672"
        cy="22.7001"
        r="17.4438"
        transform="rotate(26.3306 152.672 22.7001)"
        fill="#FFE0A0"
      />
      <circle
        cx="152.672"
        cy="22.7003"
        r="14.5014"
        transform="rotate(26.3306 152.672 22.7003)"
        fill="#FFCC60"
      />
      <path
        d="M152.677 22.468C150.541 21.411 149.519 19.1205 150.395 17.352C151.27 15.5835 153.711 15.0067 155.847 16.0637C157.552 16.9078 158.547 18.5385 158.433 20.0619"
        stroke="#813B19"
        strokeWidth="1.9498"
        strokeLinecap="round"
      />
      <path
        d="M152.467 22.3638C154.608 23.4236 155.676 25.6321 154.853 27.2966C154.029 28.961 151.625 29.4512 149.484 28.3914C147.795 27.5558 146.774 26.0064 146.821 24.5724"
        stroke="#813B19"
        strokeWidth="1.9498"
        strokeLinecap="round"
      />
      <line
        x1="156.926"
        y1="13.9337"
        x2="148.655"
        y2="30.6456"
        stroke="#813B19"
        strokeWidth="1.9498"
        strokeLinecap="round"
      />
      <path
        d="M139.675 16.2679L160.895 10.8236C156.522 7.90906 151.234 8.07482 149.137 8.52202C144.554 9.44308 140.919 14.0697 139.675 16.2679Z"
        fill="#F4A04F"
      />
      <circle
        cx="166.87"
        cy="23.8637"
        r="0.840663"
        transform="rotate(26.3306 166.87 23.8637)"
        fill="white"
      />
      <path
        d="M166.053 19.0442C166.455 18.6653 167.111 18.9899 167.053 19.5387L166.993 20.1093C166.974 20.2818 167.032 20.4537 167.152 20.5798L167.545 20.9969C167.924 21.3981 167.6 22.0541 167.051 21.9962L166.48 21.936C166.308 21.9178 166.136 21.9759 166.01 22.095L165.593 22.4889C165.192 22.8678 164.535 22.5431 164.593 21.9944L164.654 21.4238C164.672 21.2513 164.614 21.0794 164.495 20.9533L164.101 20.5362C163.722 20.135 164.046 19.4789 164.595 19.5369L165.166 19.5971C165.338 19.6153 165.51 19.5572 165.636 19.4381L166.053 19.0442Z"
        fill="white"
      />
      <path
        d="M157.957 9.67509C153.916 7.87138 144.687 6.74966 140.101 16.6924"
        stroke="#B75327"
        strokeWidth="1.1889"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_305_8103">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="clip1_305_8103">
        <rect
          width="68.7358"
          height="68.7358"
          fill="white"
          transform="translate(-3.64258 4.28564)"
        />
      </clipPath>
      <clipPath id="clip2_305_8103">
        <rect width="80" height="80" fill="white" transform="translate(114)" />
      </clipPath>
    </defs>
  </svg>
);
